<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalTitle"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        lock-scroll
        class="retry-modal"
        top="20px"
        width="1200px"
        append-to-body
        @open="handleOpen"
        :before-close="handleClose">
        <el-form ref="form" class="task-form pb20 pr20" :model="formItem" :rules="rules"
                 @keyup.enter.native="handleSubmit" label-width="90px">
            <el-form-item required label="抓取内容：" class="label-required">
                <el-radio-group v-model="formItem.retry_content" @change="changeRetryContent">
                    <el-radio-button class="radio-btn" v-if="pageFuncNames.includes('effect_data')" label="0">效果数据</el-radio-button>
                    <el-radio-button class="radio-btn" v-if="pageFuncNames.includes('basic_data')" label="1">基础数据</el-radio-button>
                </el-radio-group>
            </el-form-item>
           <template v-if="formItem.retry_content !=='1'">
                <el-form-item prop="retry_type" label="抓取方式：" class="label-required">
                    <el-radio-group v-model="formItem.retry_type" @change="changeRetryType">
                        <el-radio-button class="radio-btn" v-if="pageFuncNames.includes('data_daily_task')" :label="1">日报任务编号</el-radio-button>
                        <el-radio-button class="radio-btn" v-if="pageFuncNames.includes('data_plat_account')" :label="2">渠道账户</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="range_time" label="抓取时段：" class="label-required">
                    <el-date-picker
                        v-model="formItem.range_time"
                        type="daterange"
                        :clearable="false"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        style="width: 250px;">
                    </el-date-picker>
                </el-form-item>

                <template v-if="formItem.retry_type=='1'">
                    <el-form-item prop="choice_ids" label="选择日报：" class="label-required">
                        <ESelect
                            ref="dailyInput"
                            v-model="formItem.choice_ids"
                            multiple
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入日报任务名称或编号"
                            :remote-method="getDailyTaskList"
                            @blur="validateField('choice_ids')"
                            :loading="dailyTaskLoading"
                            style="width: 360px;"
                        >
                            <el-option
                                v-for="item in dailyTaskList"
                                :key="item.id"
                                :label="item.task_number"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </template>
           </template>
            <template v-if="formItem.retry_type=='2' || formItem.retry_content === '1'">
                <el-form-item prop="plat_id" label="选择媒体：" class="label-required">

                    <template  v-for="item in platList">
                        <el-radio
                            v-if="platWhiteList.includes(item.id) || formItem.retry_content !=='1'"
                            v-model="formItem.plat_id"
                            @change="changePlat"
                            :label="item.id"
                            :key="item.id">
                            {{item.name}}
                        </el-radio>
                    </template>
                </el-form-item>
                <el-form-item prop="choice_type" label="选择账户：" class="label-required">
                    <el-radio v-model="formItem.choice_type"  v-if="pageFuncNames.includes('by_plat_account')"  label="1" @change="changeChoiceType">按子账户</el-radio>
                    <template v-if="formItem.retry_content !=='1'">
                        <el-radio v-model="formItem.choice_type" label="2" v-if="pageFuncNames.includes('by_plat_username')" @change="changeChoiceType">{{formItem.plat_id==='10'?'经理户ID':'按二代账户'}} </el-radio>
                        <el-radio v-model="formItem.choice_type" label="3" v-if="pageFuncNames.includes('by_app')" @change="changeChoiceType">按游戏</el-radio>
                        <el-radio v-model="formItem.choice_type" label="4" v-if="pageFuncNames.includes('by_all_account')" @change="changeChoiceType">全部账户</el-radio>
                    </template>
                </el-form-item>
                <template v-if="formItem.choice_type!='4'">
                    <el-form-item label="" class="label-required">
                        <el-button v-if="formItem.choice_type=='1'||formItem.choice_type=='3'" type="primary" class="mb10" @click="showBatchModal" size="mini" plain>批量选择</el-button>

                        <div class="clearfix">
                            <div class="search-wrap fl">
                                <div>
                                    <el-input v-model="accountSearch" ref="searchInput1" @input="changeAccountSearchText" clearable placeholder="请输入查询关键字"></el-input>
                                    <div class="search-list">
                                        <ul>
                                            <li v-if="accountList.length>0&&formItem.choice_type!=2">
                                                <p class="mt10 font12px">
                                                    <span class="pointer text-color-info ml24" @click="checkAll">全选</span>
                                                </p>
                                            </li>


                                            <!--<li class="mt4 mb4" v-if="accountList.length>0&&accountSearch.length>0">-->
                                            <!--<el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox>-->
                                            <!--</li>-->
                                            <!--按子账户-->
                                            <template v-if="formItem.choice_type=='1'">
                                                <li class="" v-for="item in accountList" :key="item.account_id">
                                                    <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                                        {{formItem.plat_id=='3'?item.user_name:item.account_id}}（{{item.account_name}}）
                                                    </el-checkbox>
                                                </li>
                                            </template>
                                            <!--按二代账户-->
                                            <template v-else-if="formItem.choice_type=='2'">
                                                <li class="" v-for="item in accountList" :key="item.plat_username">
                                                    <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                                        {{item.plat_username}}（{{item.plat_company}}）
                                                    </el-checkbox>
                                                </li>
                                            </template>
                                            <!--按游戏-->
                                            <template v-else-if="formItem.choice_type=='3'">
                                                <li class="" v-for="item in accountList" :key="item.app_id">
                                                    <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                                        {{item.app_id}}（ {{item.app_name}}（账户数量：{{item.account_num}}））
                                                    </el-checkbox>
                                                </li>
                                            </template>

                                            <li class="mt4 mb4" v-if="!accountSearchLoading&&accountList.length<=0">
                                                <p class="tac text-color-gray mt10 font12px">暂无数据</p>
                                            </li>
                                            <li class="mt4 mb4" v-if="accountSearchLoading">
                                                <p class="tac text-color-gray">数据加载中...</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="page-bar tac mt20">
                                        <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="searchPn"
                                            :page-sizes="[10, 30,50]"
                                            :pager-count="5"
                                            layout="total, sizes, prev, pager, next"
                                            :total="totalCnt">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                            <div class="result-wrap fl">
                                <h3 class="font12px relative">已选（{{resultList.length}}） <span
                                    class="text-color-error pointer absolute " style="right:10px;" @click="clearResultList">清空</span>
                                </h3>
                                <div class="result-list">
                                    <ul class="mb30">

                                        <template v-if="formItem.choice_type=='1'">
                                            <li v-for="item in resultList" :key="item.account_id" class="relative mt4 mb4 font12px">
                                                {{formItem.plat_id=='3'?item.user_name:item.account_id}}（{{item.account_name}}）
                                                <span class="clear-btn pointer text-color-error p4 absolute" @click="removeResultItem(item)"
                                                      title="删除">x</span>
                                            </li>
                                        </template>
                                        <template v-else-if="formItem.choice_type=='2'">
                                            <li v-for="item in resultList" :key="item.plat_username" class="relative mt4 mb4 font12px">
                                                {{item.plat_username}}（{{item.plat_company}}）
                                                <span class="clear-btn pointer text-color-error p4 absolute" @click="removeResultItem(item)"
                                                      title="删除">x</span>
                                            </li>
                                        </template>
                                        <template v-else-if="formItem.choice_type=='3'">
                                            <li v-for="item in resultList" :key="item.app_id" class="relative mt4 mb4 font12px">
                                                {{item.app_id}}（ {{item.app_name}}（账户数量：{{item.account_num}}））
                                                <span class="clear-btn pointer text-color-error p4 absolute" @click="removeResultItem(item)"
                                                      title="删除">x</span>
                                            </li>
                                        </template>


                                    </ul>
                                </div>
                            </div>
                        </div>

                    </el-form-item>
                </template>
            </template>
            <el-form-item class="tac" label-width="0">
                <el-button type="default"
                v-matomo="{behaviorCategory: '重抓数据', event: '点击',  name: '新建任务(取消)' }"
                @click="hideModal" class="action-btn mr20">取消</el-button>
                <el-button type="primary" 
                v-matomo="{behaviorCategory: '重抓数据', event: '点击',  name: '新建任务(提交)' }"
                @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">提交
                </el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            width="520px"
            :title="'批量选择'+(formItem.choice_type=='1'?'账户':'游戏')"
            :visible.sync="batchVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="batch-modal"
            append-to-body>
            <div>
                <p class="text-color-gray mb10" v-if="formItem.choice_type=='1'">输入或粘贴账户ID，每行一个，仅支持账户ID（数字+字母）</p>
                <p class="text-color-gray mb10" v-else>输入或粘贴游戏ID，每行一个，仅支持游戏ID（数字）</p>
                <div class="batch-content">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="batchCon"
                        :rows="10"
                        resize="none"
                        style="min-height: 200px;"
                    >
                    </el-input>
                </div>
                <p class="tac mt20">
                    <el-button type="default" @click="hideBatchModal" class="action-btn mr20">取消</el-button>
                    <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="action-btn ml20">提交
                    </el-button>
                </p>
            </div>
        </el-dialog>


    </el-dialog>
</template>

<script>
    import API from '@/api/systemTool.js';
    import dayjs from 'dayjs';

    export default {
        name: "RetryTaskModal",
        props: {
            modalData: {
                type: Object,
                required: false,
            },
            action:String,
            func: Array,
            pageFuncNames: Array
        },
        data(){
            let _this = this;
            const validatePlat =  (rule, value, callback) => {
                if(_this.formItem.retry_type=='2'&&!this.formItem.plat_id){
                    return callback(new Error('请选择抓取渠道'));
                }else{
                    callback();
                }
            };
             const validateDate =  (rule, value, callback) => {
                if(_this.formItem.plat_id=='7'&&this.formItem.plat_id){
                    if (new Date(value[0]).getTime()<= new Date('2024/05/20')) {
                        callback(new Error('小米媒体24年5月20日（含）之前的数据不支持抓取，若需抓取请联系产研'));
                    }else {
                       callback();
                    }

                }else{
                    callback();
                }
            };
            const validateChoiceType =  (rule, value, callback) => {
                if(_this.formItem.retry_type=='2'&&!this.formItem.choice_type){
                    return callback(new Error('请选择抓取账户'));
                }else{
                    callback();
                }
            };
            const validateChoiceIds =  (rule, value, callback) => {
                if(_this.formItem.retry_type=='1'){
                    if(_this.formItem.choice_ids.length<=0){
                        return callback(new Error('请选择日报'));
                    }else{
                        callback();
                    }
                }else if(_this.formItem.retry_type=='2'&&_this.formItem.choice_type!='4'){
                    if(_this.resultList.length<=0){
                        return callback(new Error('请选择重抓的账户'));
                    }else{
                        callback();
                    }
                }
            };
            return {
                dialogVisible:false,
                submitLoading:false,
                platWhiteList: [ '1', '3', '7', '10', '11' ],//媒体白名单 是否支持基础数据的抓取 oppo vivo 小米 华为ADS 荣耀
                formItem:{
                    retry_content: '',// 0效果数据  1 基础数据
                    retry_type:'',     // 抓取方式：1-日报任务编号,2-渠道账户
                    range_time:[],
                    plat_id:'',     // 渠道id，受权限控制，
                    choice_type:'',     // 选择账户:1-按子账户,2-按二代账户,3-按游戏,4-全部账户
                    choice_ids:[],
                },
                rules:{
                    retry_type: [
                        { required: true, message: '请选择抓取方式', trigger: 'blur' },
                    ],
                    range_time: [
                        { required: true, message: '请选择抓取时段', trigger: 'blur' },
                        { validator: validateDate, trigger: 'blur' }
                    ],
                    plat_id:[
                        { validator: validatePlat, trigger: 'blur' }
                    ],
                    choice_type:[
                        { validator: validateChoiceType, trigger: 'blur' }
                    ],
                    choice_ids:[
                        { validator: validateChoiceIds, trigger: 'change' }
                    ],
                },
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now() || _this.formItem.plat_id==='7'&&time.getTime()<new Date('2024/05/21').getTime();
                    },
                },
                dailyTaskLoading:false,
                dailyTaskList:[],       // 日报任务列表
                accountSearchLoading:false,
                isSelectAll: false,
                accountSearch:'',
                accountList:[],
                resultList:[],
                searchTimer:null,
                totalCnt:0,
                searchPn:1,
                searchRn:10,

                /* 批量选择弹框 dialogVisible */
                batchVisible:false,
                batchCon:'',
                batchLoading:false,
            }
        },
        computed:{
            modalTitle(){
                return this.action=='copy'?'复制任务':this.action=='retry'?'重抓失败项':'新建任务';
            },
            platList() {
                const test = /^plat_\d+$/;
                return this.func.filter(v=> test.test(v.name)).map(v=>{
                    const id = v.name.substring(5);
                    return {
                        id,
                        name: v.display_name
                    }
                })
            },
            dictValue() {
                const retry_content = {
                    effect_data: '0',
                    basic_data: '1',
                    default: this.formItem.retry_content || '0',
                    value: ''
                };
                const retry_type = {
                    data_daily_task: '1',
                    data_plat_account: '2',
                    default:  '1',
                    value: ''
                };
                const choice_type = {
                    by_plat_account: '1',
                    by_plat_username: '2',
                    by_app: '3',
                    by_all_account: '4',
                    default: '1',
                    value: ''
                }
                this.func.map(v=> {
                    if (Object.keys(retry_content).includes(v.name)) {
                       const value = retry_content[v.name];
                        if (!retry_content.value || retry_content.default === value) {
                            retry_content.value = value
                        }
                    }
                    if (Object.keys(retry_type).includes(v.name)) {
                       const value = retry_type[v.name];
                        if (!retry_type.value || retry_type.default === value) {
                            retry_type.value = value
                        }
                    }
                    if (Object.keys(choice_type).includes(v.name)) {
                       const value = choice_type[v.name];
                        if (!choice_type.value || choice_type.default === value) {
                            choice_type.value = value
                        }
                    }
                });
                return {
                    retry_content: retry_content.value,
                    retry_type: retry_type.value,
                    choice_type: choice_type.value
                }

            }
        },
        methods:{
            handleOpen() {
                this.resetForm()
            },
            // 抓取内容
            changeRetryContent() {
                Object.assign(this.formItem, {
                    plat_id: (this.platList.filter(v=>this.platWhiteList.includes(v.id))[0]||{}).id||'',
                });
                this.changeChoiceType(this.dictValue.choice_type);
                this.resetForm()
            },
            initRangeTime(){
                let yesterday = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                this.formItem.range_time = [yesterday, yesterday];
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                console.log('resetForm');
                this.initRangeTime();
                Object.assign(this.formItem, {
                    ...this.dictValue
                });
                this.formItem.choice_ids =[];
                this.formItem.plat_id = (this.platList.filter(v=>this.platWhiteList.includes(v.id))[0]||{}).id||'';
                this.formItem.choice_type ='1';

                this.searchTimer = null;
                this.accountSearchLoading = false;
                this.accountSearch = '';
                this.accountList = [];
                this.resultList = [];
                this.totalCnt = 0;
                this.searchPn = 1;
                this.searchRn = 10;
                this.$refs.form?.clearValidate();
                this.dailyTaskList = [];

            },
            hideModal(){
                this.handleClose();
                this.$emit('close',this.modalData);
            },
            dailyInputFocus(){
                this.$refs.dailyInput?.focus();
                setTimeout(()=>{
                    this.$refs.form.clearValidate('choice_ids');
                },120);
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    if(this.action=='copy'||this.action=='retry'){
                        this.resetForm();
                        this.initData();
                    }else{
                        this.dailyInputFocus();
                    }
                })
            },
            initData(){

                this.formItem.retry_type = this.modalData.retry_type;
                this.formItem.retry_content = this.modalData.content_type;
                this.formItem.range_time = [dayjs(this.modalData.start).format('YYYY-MM-DD'),dayjs(this.modalData.end).format('YYYY-MM-DD')];
                if(this.action=='copy'){
                    if(this.modalData.retry_type=='1'){
                        this.getDailyTaskList(this.modalData.detail_list);
                        this.formItem.choice_ids = this.modalData.detail_list_for_copy.map(item=>item.id);
                    }else if(['2', '0'].includes(this.modalData.retry_type)){
                        this.formItem.plat_id = this.modalData.plat_id;
                        this.formItem.choice_type = this.modalData.choice_type;
                        this.resultList = this.modalData.detail_list_for_copy.map(item=>{
                            item.checked = true;
                            return item;
                        });
                    }
                }else if(this.action=='retry'){
                    // err_account_list
                    if(this.modalData.retry_type=='1'){
                        this.getDailyTaskList(this.modalData.err_list.map(item=>item.task_number));
                        this.formItem.choice_ids = this.modalData.err_list.map(item=>item.id);
                    }else if(['2', '0'].includes(this.modalData.retry_type)){
                        this.formItem.plat_id = this.modalData.plat_id;
                        this.formItem.choice_type = this.modalData.choice_type;
                        this.resultList = this.modalData.err_list.map(item=>{
                            item.checked = true;
                            return item;
                        });
                    }
                }
            },
            handleSubmit() {
                // addRetryTask
                /*
                * retry_content: 抓取内容
                * retry_type:抓取方式,1-日报任务编号,2-渠道账户
                * range_time:抓取时段,
                * plat_id:渠道账户时需要，
                * choice_type:选择账户,1-按子账户,2-按二代账户,3-按游戏,4-全部账户
                * choice_ids:对应id，要数组格式
                * */

                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        const { retry_type, choice_type, retry_content, plat_id,  } = this.formItem
                        if((retry_type=='2'&&choice_type!='4'|| retry_content ==='1')&&this.resultList.length<=0){
                            return this.$message.error('请选择重抓的账户');
                        }

                        this.submitLoading = true;
                        const errTip =  (error)=> {
                             if (error.data?.length) {
                                const tip = error.data.map(({ id, name })=> {
                                    return `<p>${name}(${id})</p>`
                                }).join('');
                                this.$confirm(`<p>${error.info}</p><div style='max-height:300px;overflow: auto;padding: 6px 0'>${tip}</div>` , '提示', {
                                    confirmButtonText: '剔除',
                                    cancelButtonText: '取消',
                                    dangerouslyUseHTMLString: true,
                                    type: 'warning'
                                }).then(() => {
                                    error.data.map(({id})=> {
                                        this.removeResultItem({
                                            account_id: id
                                        })
                                    });
                                    this.handleSubmit()
                                }).catch(() => {});
                            }else {
                                this.$message.error(error.info || '操作失败');
                            }
                        }

                        if (retry_content === '1') {
                            const params = {
                                content_type:retry_content, plat_id, choice_type,
                                choice_ids: this.resultList.map(v=>v.account_id),
                                retry_type: '0'
                            }
                            try {
                                const result = await API.addRetryTask(params)
                                this.$message.success(result.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                            } catch (error) {
                               errTip(error)
                            }finally {
                                this.submitLoading = false;
                            }
                        }else {
                            let resData = {
                                retry_type:this.formItem.retry_type,
                                range_time:this.formItem.range_time.join('/'),
                            };

                            if(this.formItem.retry_type=='1'){
                                resData.choice_ids = this.formItem.choice_ids
                            }else{
                                let choiceIds = this.resultList.map(item=>{
                                    if(this.formItem.choice_type=='1'){
                                        return item.account_id;
                                    }else if(this.formItem.choice_type=='2'){
                                        return item.plat_username;
                                    }else if(this.formItem.choice_type=='3'){
                                        return item.app_id;
                                    }
                                });

                                resData.plat_id = this.formItem.plat_id;
                                resData.choice_type = this.formItem.choice_type;
                                resData.choice_ids = this.formItem.choice_type=='4'?null:choiceIds;
                            }

                            API.addRetryTask(resData).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                                this.submitLoading = false;
                            }, (err) => {
                                errTip(err)
                                this.submitLoading = false;
                            });
                        }



                    } else {
                        return false;
                    }
                });
            },
            getDailyTaskList(query){
                if (query !== '') {
                    this.dailyTaskLoading = true;
                    API.getRetrySearchList({
                        retry_type:this.formItem.retry_type,
                        range_time:this.formItem.range_time.join('/'),
                        search:query,
                    }).then(res => {
                        let resData = res.data||[];
                        this.dailyTaskLoading = false;
                        this.dailyTaskList = resData;
                    },(err) => {
                        console.log('getRetrySearchList err',err);
                        this.dailyTaskLoading = false;
                        this.dailyTaskList = [];
                    })
                } else {
                    this.dailyTaskList = [];
                }
            },
            changeAccountSearchText(query){
                console.log('changeAccountSearchText',query);

                if(this.searchTimer){
                    clearTimeout(this.searchTimer);
                    this.searchTimer = null;
                }
                this.searchTimer = setTimeout(()=>{
                    if(!query){
                        if(this.formItem.choice_type=='2'){
                            this.getDataList();
                        }else{
                            this.accountList = [];
                            this.totalCnt = 0;
                            this.accountSearchLoading = false;
                        }
                    }else{
                        this.getDataList();
                    }
                },300)
            },
            changeRetryType(val){
                this.formItem.choice_ids = [];
                this.formItem.plat_id = (this.platList[0]||{}).id||'';
                this.formItem.choice_type = '1';
                this.changeChoiceType(val==2?'1':null);
                this.$refs.form.clearValidate();
                if(val=='1'){
                    this.dailyInputFocus();
                }
            },
            changePlat(){
                this.formItem.choice_type = '1';
                this.changeChoiceType('1');
            },
            changeChoiceType(val){
                this.resultList = [];
                this.accountList = [];
                this.accountSearch = '';
                this.totalCnt = 0;
                this.searchPn = 1;
                this.searchRn = 10;
                clearTimeout(this.searchTimer);
                this.searchTimer = null;
                this.accountSearchLoading = false;
                this.$nextTick(()=>{
                    /* 二代账户 显示全部 */
                    if(val=='1'||val=='3'){
                        this.$refs.searchInput1&&this.$refs.searchInput1.focus();
                    }else if(val=='2'){
                        this.getDataList();
                    }
                })

            },
            itemCheckChange(item, val){
                let resultIndex = null;
                if(this.formItem.choice_type=='1'){
                    resultIndex = this.resultList.findIndex(inner => inner.account_id == item.account_id);
                }else if(this.formItem.choice_type=='2'){
                    resultIndex = this.resultList.findIndex(inner => inner.plat_username == item.plat_username);
                }else if(this.formItem.choice_type=='3'){
                    resultIndex = this.resultList.findIndex(inner => inner.app_id == item.app_id);
                }

                if (val) {
                    if (resultIndex == '-1') {
                        this.resultList.unshift(item);
                    }
                } else {
                    if (resultIndex != '-1') {
                        this.resultList.splice(resultIndex, 1);
                    }
                }
            },
            clearResultList(){
                this.resultList = [];
                this.accountList.forEach(item => {
                    item.checked = false;
                });
            },
            removeResultItem(item){
                console.log('removeResultItem',item,this.formItem.choice_type);
                let resultIndex = null;
                let searchIndex = null;

                if(this.formItem.choice_type=='1'){
                    resultIndex = this.resultList.findIndex(inner => inner.account_id == item.account_id);
                    searchIndex = this.accountList.findIndex(inner => inner.account_id == item.account_id);
                }else if(this.formItem.choice_type=='2'){
                    resultIndex = this.resultList.findIndex(inner => inner.plat_username == item.plat_username);
                    searchIndex = this.accountList.findIndex(inner => inner.plat_username == item.plat_username);
                }else if(this.formItem.choice_type=='3'){
                    resultIndex = this.resultList.findIndex(inner => inner.app_id == item.app_id);
                    searchIndex = this.accountList.findIndex(inner => inner.app_id == item.app_id);
                }

                if (resultIndex != '-1') {
                    this.resultList.splice(resultIndex, 1);
                }
                if (searchIndex != '-1') {
                    this.accountList[searchIndex].checked = false;
                }
            },
            handleSizeChange(val) {
                this.searchRn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.searchPn= val;
                this.getDataList();
            },
            getDataList(){
                this.accountSearchLoading = true;
                this.accountList = [];
                const { retry_content } = this.formItem
                const params = {

                    plat_id:this.formItem.plat_id,
                    choice_type:this.formItem.choice_type,
                    search:this.accountSearch,
                    pn:this.searchPn,
                    rn:this.searchRn,

                };
                if (retry_content !== '1') {
                    Object.assign(params, {
                        retry_type:this.formItem.retry_type,
                        range_time:this.formItem.range_time.join('/'),
                    })
                }
                API.getRetrySearchList(params).then(res => {
                    let resData = res.data||{};
                    this.accountSearchLoading = false;
                    let resList = resData.list||[];
                    this.accountList = resList.map(item=>{
                        if(this.formItem.choice_type=='1'){
                            item.checked = !!this.resultList.find(inner => inner.account_id == item.account_id);
                        }else if(this.formItem.choice_type=='2'){
                            item.checked = !!this.resultList.find(inner => inner.plat_username == item.plat_username);
                        }else if(this.formItem.choice_type=='3'){
                            item.checked = !!this.resultList.find(inner => inner.app_id == item.app_id);
                        }
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                },(err) => {
                    console.log('getRetrySearchList err',err);
                    this.accountSearchLoading = false;
                    this.accountList = [];
                })
            },
            showBatchModal(){
                console.log('showBatchModal');
                this.batchVisible = true;
            },
            hideBatchModal(){
                this.batchVisible = false;
                this.batchCon = '';
            },
            submitBatchModal(){

                let accountSearch = this.batchCon.split(/\n/).filter(item=>!!item);

                API.getRetrySearchList({
                    content_type: this.formItem.retry_content,
                    retry_type:this.formItem.retry_type,
                    range_time:this.formItem.range_time.join('/'),
                    plat_id:this.formItem.plat_id,
                    choice_type:this.formItem.choice_type,
                    search:accountSearch,
                }).then(res => {
                    this.batchLoading = false;
                    let resData = res.data||{};
                    let errList = resData.err_list||[];
                    let successList =  resData.list||[];
                    if(errList.length>0){

                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下'+(this.formItem.choice_type=='1'?'账户':'游戏')+'ID，请检查后重试：</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$alert(htmlStr, '提示', {
                            confirmButtonText: '知道了',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                        });
                    }else{
                        console.log('successList',successList);

                        let typeMap = {
                            1:'account_id',
                            2:'plat_username',
                            3:'app_id',
                        };
                        let curType = typeMap[this.formItem.choice_type];

                        successList.forEach(item=>{
                            let resultIndex = this.resultList.findIndex(inner=>inner[curType]==item[curType]);
                            let dataItem = this.accountList.find(inner=>inner[curType]==item[curType]);
                            if(resultIndex<0){
                                this.resultList.unshift(item);
                            }
                            if(dataItem){
                                dataItem.checked = true;
                            }
                        });
                        this.batchLoading = false;
                        this.batchVisible = false;
                        this.batchCon = '';

                        // this.resultList
                    }
                },(err) => {
                    console.log('getRetrySearchList err',err);
                    this.batchLoading = false;
                })



            },
            validateField(field){
                console.log('validateField',field);
                this.$refs.form.validateField(field);
            },
            checkAll(){
                this.accountList.forEach(item=>{
                    if(!item.checked){
                        item.checked = true;
                        this.itemCheckChange(item,true);
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .task-form{
        margin: 0 30px;
    }
    ::v-deep .radio-btn .el-radio-button__inner{
        width: 125px;
    }
    .action-btn{
        width: 125px;
    }

    .result-wrap, .search-wrap {
        width: 50%;
        border: solid 1px #ccc;
        padding: 10px;
        height: 300px;
        overflow: hidden;
    }

    .result-wrap {
        position: relative;
        left: -1px;
    }

    .result-list {
        margin-top: 5px;
        height: 265px;
        overflow-y: auto;
        li{
            white-space: normal;
            line-height: 20px;
            padding: 0 20px 0 10px;
            &:hover{
                background-color: #f8f8f9;
            }
        }
        .clear-btn{
            padding: 0 8px;
            right: 0;
            top: 0;
        }
    }


    .search-list {
        width: 100%;
        min-height: 200px;
        max-height: 200px;
        overflow-y: auto;
        padding: 6px;
    }

    ::v-deep.batch-modal .el-dialog__body{
        padding: 10px 20px 20px;
    }

    ::v-deep .page-bar .el-input__inner{
        border-color: #DCDFE6!important;
    }

    ::v-deep .retry-modal .el-dialog__body{
        padding: 20px;
    }

</style>
